import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";
import { getBranches } from "./queries";

const BranchesContext = createContext({});

export const useBranchesContext = () => useContext(BranchesContext);

export const BranchesProvider = ({ ...props }) => {
  const [branches, setBranches] = useState([]);

  const fetchBranches = useCallback(async () => {
    if (branches.length === 0) {
      try {
        const result = await getBranches();
        if (Array.isArray(result)) {
          result.sort((a, b) => a.name.localeCompare(b.name));
          setBranches(result);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [branches]);

  const values = useMemo(
    () => ({
      branches,
      fetchBranches,
    }),
    [branches, fetchBranches]
  );

  return <BranchesContext.Provider value={values} {...props} />;
};
